<!--
svg sprite
AT
21.09.20
-->

<script>
	export let css
	export let symbol
	let file = '/site/assets/svg/sprite.symbol.svg'
</script>

<svg class="{ css }">
	<use xlink:href="{ file }#{ symbol }"></use>
</svg>